import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, tap } from 'rxjs';
import { IRevenue } from '../interfaces/revenue/irevenue';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RevenueService {
  constructor(private http: HttpClient) {}
  moveFoward(array : any[],key: string) {
   let index = array.findIndex(item => item.nameCategory.toUpperCase() === key);
   let [item] = array.splice(index,1);
   item.disableInactive = true;
   array.unshift(item);  
  }
  getAll() {
    return this.http
      .get(`${environment.url}/revenues`)
      .pipe(map((res: any) => res['hydra:member']),map((res) => {
        ['OUTROS','PARCERIAS','PROCEDIMENTOS','EXAMES','ATENDIMENTOS'].forEach(key => this.moveFoward(res,key));
        return res;
      })
    
    ) as Observable<IRevenue[]>;
  }

  save(req: IRevenue) {
    return this.http.post(
      `${environment.url}/revenues`,
      req
    ) as Observable<IRevenue>;
  }

  //inativar falta (trocar delete por inativar)

  inactivate(id: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json',
    });
    return this.http.patch(`${environment.url}/revenues/${id}`, {
      status: false,
    },
    { headers: headers }
    ) as Observable<IRevenue>;
  }

  activate(id: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json',
    });
    return this.http.patch(`${environment.url}/revenues/${id}`, {
      status: true,
    },
    { headers: headers }
    ) as Observable<IRevenue>;
  }

  edit(req: IRevenue, id: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json',
    });
    return this.http.patch(
      `${environment.url}/revenues/${id}`,
      req,
      { headers: headers }
    ) as Observable<IRevenue>;
  }
}
